import { LOGOS_SET } from "@common/constants/action-types";
export default function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case LOGOS_SET:
            return action.payload;
        default:
            return state;
    }
}
